export default __webpack_public_path__ + "static/satin-1-8610a960aeb214ae443474679a006532.jpeg";